export var EKeyboardKey = /*#__PURE__*/function (EKeyboardKey) {
  EKeyboardKey["Space"] = " ";
  EKeyboardKey["Enter"] = "Enter";
  EKeyboardKey["Escape"] = "Escape";
  EKeyboardKey["Backspace"] = "Backspace";
  EKeyboardKey["Delete"] = "Delete";
  EKeyboardKey["ArrowLeft"] = "ArrowLeft";
  EKeyboardKey["ArrowUp"] = "ArrowUp";
  EKeyboardKey["ArrowRight"] = "ArrowRight";
  EKeyboardKey["ArrowDown"] = "ArrowDown";
  EKeyboardKey["Home"] = "Home";
  EKeyboardKey["End"] = "End";
  EKeyboardKey["PageUp"] = "PageUp";
  EKeyboardKey["PageDown"] = "PageDown";
  return EKeyboardKey;
}({});